import { defineField } from '../fieldBuilder';

import type { RequestFieldDefinition } from '../types';

const step = 'liquid-cooling' as const;
const stepOnly = { step: true, summary: false } as const;

/** liquid-cooling — full step field catalog (Summary + step-only system/loop blocks). */
export const LIQUID_COOLING_FIELDS: readonly RequestFieldDefinition[] = [
  defineField(
    step,
    'project',
    0,
    'lcLiquidToChipDesired',
    'Is liquid-to-chip cooling desired?',
    'L2C desired',
  ),
  defineField(step, 'project', 1, 'lcCduType', 'Rack or Row CDUs', 'CDU type'),
  defineField(
    step,
    'project',
    2,
    'lcDescription',
    'Description',
    'Description',
  ),
  defineField(
    step,
    'project',
    3,
    'lcVertivSuppliesRowManifolds',
    'Does Vertiv supply row manifolds (row CDUs)?',
    'Row manifolds',
  ),
  defineField(
    step,
    'project',
    4,
    'lcVertivSuppliesRackManifolds',
    'Does Vertiv supply rack manifolds (rack CDUs)?',
    'Rack manifolds',
  ),
  defineField(
    step,
    'project',
    5,
    'lcCduRedundancy',
    'CDU redundancy',
    'Redundancy',
  ),
  defineField(
    step,
    'project',
    6,
    'lcLeakDetectionApproach',
    'Leak detection control approach',
    'Leak detection',
  ),
  defineField(
    step,
    'additionalInformation',
    0,
    'lcAdditionalInformationSfn',
    'Additional Liquid Cooling Information',
    'Notes',
  ),
  defineField(
    step,
    'systemLevel',
    0,
    'lcTotalLiquidCoolingThermalLoadPerSfn',
    'Total liquid cooling thermal load per SFN (kW)',
    'Thermal load',
    stepOnly,
  ),
  defineField(
    step,
    'systemLevel',
    1,
    'lcNumberOfLiquidCooledRacksToBeServed',
    'Number of liquid cooled racks to be served',
    'Liquid racks',
    stepOnly,
  ),
  defineField(
    step,
    'systemLevel',
    2,
    'lcNumberOfAirCooledRacks',
    'Number of air cooled racks',
    'Air racks',
    stepOnly,
  ),
  defineField(
    step,
    'systemLevel',
    3,
    'lcLiquidCoolingVsPeakRackItLoad',
    'Liquid cooling vs peak rack IT load',
    'LC vs peak',
    stepOnly,
  ),
  defineField(
    step,
    'systemLevel',
    4,
    'lcTotalItLoadPerDataHall',
    'Total IT load per data hall',
    'IT load',
    stepOnly,
  ),
  defineField(
    step,
    'systemLevel',
    5,
    'lcRedundancyStrategy',
    'Redundancy strategy',
    'Redundancy',
    stepOnly,
  ),
  defineField(
    step,
    'primaryLoop',
    0,
    'lcEthyleneGlycolPct',
    'Coolant — Ethylene Glycol % (0=Water)',
    'Glycol %',
    stepOnly,
  ),
  defineField(
    step,
    'primaryLoop',
    1,
    'lcTps',
    'TPS — Primary supply temperature',
    'TPS',
    stepOnly,
  ),
  defineField(
    step,
    'primaryLoop',
    2,
    'lcTpr',
    'TPR — Primary return temperature',
    'TPR',
    stepOnly,
  ),
  defineField(
    step,
    'primaryLoop',
    3,
    'lcConnectionTypePrimary',
    'Primary connection type',
    'Connection',
    stepOnly,
  ),
  defineField(
    step,
    'primaryLoop',
    4,
    'lcPrimaryFlowValve',
    'Primary flow valve',
    'Flow valve',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    0,
    'lcCoolant',
    'Secondary coolant',
    'Coolant',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    1,
    'lcTss',
    'TSS — Secondary supply temperature',
    'TSS',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    2,
    'lcTsr',
    'TSR — Secondary return temperature',
    'TSR',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    3,
    'lcFlowrateRequirement',
    'Flow rate requirement',
    'Flow rate',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    4,
    'lcFiltration',
    'Filtration',
    'Filtration',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    5,
    'lcMaximumPressureRating',
    'Maximum pressure rating',
    'Max pressure',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    6,
    'lcRackPressureDrop',
    'Rack pressure drop',
    'Rack ΔP',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    7,
    'lcExternalStaticPressureRequirement',
    'External static pressure requirement',
    'Static pressure',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    8,
    'lcConnectionTypeSecondary',
    'Secondary connection type',
    'Connection',
    stepOnly,
  ),
  defineField(
    step,
    'secondaryLoop',
    9,
    'lcSecondaryFluidNetwork',
    'Secondary fluid network',
    'Fluid network',
    stepOnly,
  ),
];
